import toastr from 'toastr'
import { store } from '../../store'
import { generateDefaultHttpBuilder } from '@/utils/http/httpBuilderPresets'
import { pipe } from '@/utils/functionalBob'
import { HTTP_METHODS } from './httpBuilder'

const MAX_RETY = 2
const LOGIN_URL = '/app/Merchant/#/Login'

export default class HttpWrapper {
  static noop () {}

  static failedRequest (res) {
    return (res === undefined || !/2[0-9][0-9]/.test(res.status || (res.response && res.response.status)))
  }

  static unauthorized (res) {
    return /401/.test(res && (res.status || (res.response && res.response.status)))
  }

  // static captureError (res) {
  //   const baseMessage = 'Error occurred!'
  //   let errorMessage = typeof res.data === 'object' ? res.statusText : res.data || res.response ? res.response.data : ''
  //   if (errorMessage === undefined || errorMessage.length === 0 || typeof errorMessage === 'object') errorMessage = baseMessage
  //   return errorMessage
  // }

  static displayErrorMessage (res) {
    const baseMessage = 'Error occurred!'
    let errorMessage = typeof res.data === 'object' ? res.statusText : res.data || res.response ? res.response.data : ''

    if (typeof errorMessage === 'object') {
      errorMessage = `${errorMessage?.data?.title || errorMessage?.data?.Message || errorMessage.Message}`
    } else if (errorMessage === undefined || errorMessage.length === 0) errorMessage = baseMessage

    toastr.error(errorMessage)
    return res
  }

  static extendRequest (request, opts) {
    const Headers = Object.assign({}, request.Headers, opts.Headers)
    return Object.assign({}, request, opts, { Headers })
  }

  static addAuthHeaders (request, headersObj) {
    const { accesstoken } = headersObj
    const Headers = typeof accesstoken === 'undefined' ? {} : { Authorization: `Bearer ${accesstoken}` }
    return this.extendRequest(request, { Headers })
  }

  static maxRetry (retry) {
    return retry >= MAX_RETY
  }

  static async Delete (...args) {
    return await this.Call(HTTP_METHODS.DELETE, ...args)
  }

  static async Put (...args) {
    return await this.Call(HTTP_METHODS.PUT, ...args)
  }

  static async Post (...args) {
    return await this.Call(HTTP_METHODS.POST, ...args)
  }

  static async Get (...args) {
    return await this.Call(HTTP_METHODS.GET, ...args)
  }

  static async goToLogin () {
    setTimeout(function () {
      store.dispatch('user/resetUser')
      store.dispatch('resetAuthentication')
      window.location.replace(LOGIN_URL)
    }, 0)
  }

  static async Call (type, request, successCb = this.noop, failCb = this.noop, disableErrorMessages = false) {
    let { Url, Data, Headers, Params, ResponseType } = request
    if (!Headers) Headers = {}
    if (!Params) Params = {}
    const builder = generateDefaultHttpBuilder()
    switch (type) {
      case HTTP_METHODS.GET:
        builder.asGet()
        break
      case HTTP_METHODS.POST:
        builder.asPost()
        break
      case HTTP_METHODS.PUT:
        builder.asPut()
        break
      case HTTP_METHODS.DELETE:
        builder.asDelete()
        break
    }

    const fail = failCb || this.noop
    const failedSideEffect = disableErrorMessages ? fail : pipe(this.displayErrorMessage, fail)
    const successSideEffect = successCb || this.noop
    return await builder
      .withUrl(Url)
      .withHeaders(Headers)
      .withParams(Params)
      .withResponseType(ResponseType)
      .withBody(Data)
      .withFailedSideEffect(failedSideEffect)
      .withSuccessSideEffect(successSideEffect)
      .send()
  }

  static async Exec ({
    type,
    request,
    successSideEffect = this.noop,
    failedSideEffect: failCb = this.noop,
    successStrategy = this.noop,
    failedStrategy = this.noop,
    noContentStrategy = this.noop,
    disableErrorMessages = false
  }) {
    let { Url, Data, Headers, Params, ResponseType } = request
    if (!Headers) Headers = {}
    if (!Params) Params = {}
    const builder = generateDefaultHttpBuilder()
    switch (type) {
      case HTTP_METHODS.GET:
        builder.asGet()
        break
      case HTTP_METHODS.POST:
        builder.asPost()
        break
      case HTTP_METHODS.PUT:
        builder.asPut()
        break
      case HTTP_METHODS.DELETE:
        builder.asDelete()
        break
    }
    const failedSideEffect = disableErrorMessages ? failCb : pipe(this.displayErrorMessage, failCb)
    return await builder
      .withUrl(Url)
      .withHeaders(Headers)
      .withParams(Params)
      .withResponseType(ResponseType)
      .withBody(Data)
      .withFailedSideEffect(failedSideEffect)
      .withSuccessSideEffect(successSideEffect)
      .withFailedStrategy(failedStrategy)
      .withSuccessStrategy(successStrategy)
      .withNoContentStrategy(noContentStrategy)
      .send()
  }
}
